import Component from 'inferno-component';
import './Search.css';
import './SearchMobile.css';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = { value: props.searchString };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searchString !== this.state.value) {
      this.setState({ value: nextProps.searchString });
    }
  }

  handleChange = (event)=> {
    this.setState({ value: event.target.value });
    this.props.onInput(event.target.value);
  }

  render() {
    return (
      <div className="search">
        <div className="search-controls">
          <input type="text" value={ this.state.value } onInput={ this.handleChange } placeholder="Skill search" />
          <i className="icon-search"></i>
          <i className="clear"></i>
        </div>
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/Search/Search.js